// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__1fusd","thinking-face":"NotFound_thinking-face__LY0jc"};